import { render } from "./SecondModel.vue?vue&type=template&id=90048cee"
import script from "./SecondModel.vue?vue&type=script&lang=js"
export * from "./SecondModel.vue?vue&type=script&lang=js"

import "./SecondModel.vue?vue&type=style&index=0&id=90048cee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__